import * as Yup from 'yup';

import { CloudFunctionsService, FirebaseService } from '@services';
import { AppConfig } from '@types';
import { formatNumberToCurrencyString, translate, rollbar } from '@utils';

export const getValidationSchema = async () => {
  const firebaseService = new FirebaseService(new CloudFunctionsService());

  const getAppConfig = async (): Promise<AppConfig | null> => {
    try {
      return await firebaseService.getFirebaseRemoteConfig('app_config');
    } catch (err) {
      rollbar.error('Failed to load app configuration:', err as Error);
      return null;
    }
  };

  const appConfig = await getAppConfig();

  if (!appConfig) {
    throw new Error('Failed to load app configuration.');
  }

  return Yup.number()
    .typeError(translate('subModules/debtAmount:validation.validDollarAmount'))
    .positive(translate('subModules/debtAmount:validation.validDollarAmount'))
    .max(
      appConfig.maximumDebtAmount,
      translate('subModules/debtAmount:validation.validMaxDollarAmount', {
        amount: formatNumberToCurrencyString(appConfig.maximumDebtAmount),
      })
    )
    .required(translate('subModules/debtAmount:validation.required'));
};
